import script from "./AccountTabsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountTabsBar.vue?vue&type=script&setup=true&lang=js"

import "./AccountTabsBar.vue?vue&type=style&index=0&id=531c837f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531c837f"]])

export default __exports__